<template>
<div :class="{'pt-5': layout}" class="my-auto">
    <Search
        @cleanFilter="cleanFilter"
        @searchInput="e => getPlans(e)"
        @categoryFilter="e => planCategory = e"
        :plan-categories="planCategory"
        :categories="categories"
    />
    <template v-if="plans && plans.length">
        <section :class="{ 'cards-fixed': layout }" class="cards">
            <dashboard-plan-card
                v-for="plan in plans"
                :key="plan.id"
                :plan="plan"
                :color="color"
                :layout-buttons="layoutButtons"
            />
        </section>
        <div v-if="meta.total > perPage" class="d-flex justify-content-center mt-5">
            <base-pagination
                :page-count="meta.last_page"
                v-model="meta.current_page"
                @input="onChangePage"
                type="#525F7F"
            />
        </div>
    </template>
    <card v-else class="container mt-4">
        <Empty
            :color="color"
            @redirect="goBack"
            :button-label="$t('dashboard.redirect_showcase')"
            :icon="'fa-exclamation-circle'"
        >
            <template #title><h1 class="font-weight-medium mb-0">{{$t('dashboard.no_plans')}}</h1></template>
            <template #subtitle><p>{{$t('dashboard.empty_message')}}.</p></template>
        </Empty>
    </card>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import debounce from '../../helpers/helpers';

import Card from '../../argon/components/Cards/Card';
import BasePagination from '../../argon/components/BasePagination';

import Empty from '../Common/Empty';
import DashboardPlanCard from './DashboardPlanCard';
import Search from '../Search';


export default {
    name: 'DashboardPlans',
    components: {
        Card,
        DashboardPlanCard,
        BasePagination,
        Empty,
        Search,
    },
    props: {
        categories: Array,
        color: {
            type: Object,
            required: true,
        },
        layoutButtons: {
            type: Object,
            required: true,
        },
        token: String,
    },
    data() {
        return {
            plans: [],
            links: {},
            meta: {},
            perPage: 6,
            loading: true,
            planCategory: [],
        };
    },

    computed: mapGetters({ layout: 'NAVBAR_FIXED' }),

    methods: {
        getPlans(search = '') {
            this.$loading.show();

            window.axios
                .get('/api/app/dashboard/plans', {
                    params: {
                        per_page: this.perPage,
                        page: this.meta.current_page
                            ? this.meta.current_page
                            : 1,
                        categories: this.planCategory.length > 0 ? this.planCategory : null,
                        search,
                    },
                })
                .then((res) => {
                    this.plans = res.data.data;
                    this.links = res.data.links;
                    this.meta = res.data.meta;
                })
                .catch(err => console.log(err))
                .finally(() => {
                    this.$loading.close();
                });
        },
        onChangePage(page) {
            this.meta.current_page = page;
            this.getPlans();
        },
        goBack() {
            this.$loading.show();
            window.location.href = '/plans';
        },
        cleanFilter() {
            this.planCategory = [];
            this.search = '';
            this.getPlans();
        },
    },

    watch: {
        planCategory() {
            debounce(() => {
                this.meta.current_page = 1;
                this.getPlans(this.search);
            }, 300).call();
        },
    },
    async beforeMount() {
        if (this.token) {
            await localStorage.setItem("nochalks_token", this.token);
        }
    },
    mounted() {
        this.getPlans();
    },
};
</script>

<style>

.cards {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 30px;
    max-width: 1100px;
    margin: 0 auto 30px;
    padding: 40px 20px;
}

.cards-fixed {
    margin-top: 58px !important;
}
</style>
